module.exports = __webpack_public_path__ + "static/media/1-8.f1986ec4.mp3";